import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import {
  BannersTable,
  CreateBannerModal,
  useBannersList
} from "modules/banners";
import { Button, Pagination, SearchInput } from "ui";

import styles from "./Banners.module.scss";

const Banners = () => {
  const {
    value: isOpenBannerModal,
    setTrue: onOpenBannerModal,
    setFalse: onCloseBannerModal
  } = useBoolean();

  const {
    banners,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    setBanners
  } = useBannersList();

  return (
    <ContentLayout
      title={t("Banners")}
      action={
        <Button onClick={onOpenBannerModal} icon={<PlusInSquareIcon />}>
          {t("New Banner")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />

        <BannersTable
          bannersList={banners}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          setBanners={setBanners}
          isDragDisabled={!!searchValue || sorting.length > 0}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <CreateBannerModal
        isOpen={isOpenBannerModal}
        onClose={onCloseBannerModal}
      />
    </ContentLayout>
  );
};

export default Banners;
